import {
  CREATE_ADMIN_URL,
  GET_DSO_ADMIN_CATEGORY_URL,
  GET_DSO_URL,
  UPDATE_ADMIN_URL,
} from "../../../config/adminUrlConfig";
import { ApiService } from "../../../config/apiServices";
import {
  GET_DISTRICT_URL,
  GET_STATE_URL,
} from "../../../config/commonApiUrl/CommonApiUrlConfig";

export const getDistrictData = (id) => {
  try {
    return ApiService.get(`${GET_DISTRICT_URL}${id}`);
  } catch (error) {
    return error.message;
  }
};
export const getStateData = (id) => {
  try {
    return ApiService.get(`${GET_STATE_URL}${id}`);
  } catch (error) {
    return error.message;
  }
};

export const createDSO = (payload) => {
  try {
    return ApiService.post(`${CREATE_ADMIN_URL}`, payload);
  } catch (error) {
    return error.message;
  }
};

export const getDSOList = (sort_by = "", order_by = "desc", perPage = 10,
  currentPage = 1) => {
  try {
    return ApiService.get(
      `${GET_DSO_URL}?sort_by=${sort_by}&order_by=${order_by}&number=${perPage}&page=${currentPage}`
    );
  } catch (error) {
    return error.message;
  }
};

export const updateDSO = (id, payload) => {
  try {
    return ApiService.put(`${UPDATE_ADMIN_URL}/${id}`, payload);
  } catch (error) {
    return error.message;
  }
};

export const getDsoAdminCategory = (id, payload) => {
   try {
    return ApiService.get(GET_DSO_ADMIN_CATEGORY_URL);
  } catch (error) {
    return error.message;
  }
};
